import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { useQuery, keepPreviousData } from '@tanstack/react-query';

export const TAXONOMY_SEARCH_QUERY_KEY = 'taxonomy.search';

export const useSearchTaxonomyNodes = (taxonomyId: string | undefined, query: string) => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();
  const trimmedQuery = query.trim();

  const result = useQuery({
    queryKey: [TAXONOMY_SEARCH_QUERY_KEY, tenantId, taxonomyId, trimmedQuery],
    queryFn: () => api.taxonomy.searchTaxonomyNodes({ tenantId, taxonomyId: taxonomyId!, query: trimmedQuery }),
    enabled: Boolean(tenantId) && Boolean(taxonomyId) && trimmedQuery.length > 0,
    retry: false,
    placeholderData: keepPreviousData,
  });

  return {
    results: result.data?.data.results ?? [],
    isLoading: result.isLoading,
    isFetching: result.isFetching,
  };
};
